import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connectStore } from "redux-box";
import { module as inviteCode } from "@st/inviteCode";
import { module as product } from "@st/product";
import { module as onboard } from "@st/onboard";
import Select from "react-select";
import CheckBox from "./CheckBox";
import {
  DropDownContainer,
  DropDownTitle,
  DatePickerContainer,
} from "./SchoolIroEnable.styled";
import { Th, Td, Tr, Table, Grade } from "./SchoolIroEnable.styled";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  DateSelector,
  DateSelectorIcon,
} from "../../flive-code-view/renewalold-school/RenewalOldSchool.styled";
import Tree from "rc-tree";
import userApi from "../../../services/api/user";
import { MOCK_ASSESSMENT_ID } from "../../../utils/constant";

const userTypes = [
  {
    label: "Students",
    value: "students",
  },
  {
    label: "Teachers",
    value: "teachers",
  },
  {
    label: "Both",
    value: "both",
  },
];

const examSections = [
  {
    label: "Reading Comprehension",
    value: "Reading Comprehension",
  },
  {
    label: "Full Assessment",
    value: "Full Assessment",
  }
];

function SchoolIroEnable(props) {
  const [gradeOption, setGradeOption] = useState([]);
  const [schoolIroEnableData, setSchoolIroEnableData] = useState({
    isEnableSchoolIro: false,
    school: null,
    selectedGrades: [],
    // selectedDate : moment().format("YYYY-MM-DD")
    // examDate: "",
    examDatesTable: [],
    test_id: "",
    examStatus: null,
    user_type: "",
    selectedSections: [],
    exam_section: "",
    start_date:"",
    end_date:""
  });

  const [examOptions, setExamOptions] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

  useEffect(() => {
    let { schoolEditInfo } = props.inviteCode;
    if (schoolEditInfo) {
      setSchoolIroEnableData({
        ...schoolIroEnableData,
        school: schoolEditInfo.id,
      });
      props.inviteCode.getSchoolIro(schoolEditInfo.id);
    }
    props.inviteCode.getAllGrades();
    if (!props.inviteCode.iroExamTypes || props.inviteCode.iroExamTypes.length === 0) props.inviteCode.getIroExamTypes();
  }, []);

  useEffect(() => {
    let gradesList = props.inviteCode.allGrades.map((grade) => {
      return {
        value: grade.id,
        label: grade.name,
      };
    });
    setGradeOption(gradesList);
  }, [props.inviteCode.allGrades]);

  useEffect(() => {
    if (props.inviteCode.iroExamTypes.length > 0) {
      let updatedTypes = props.inviteCode.iroExamTypes
        .filter((exam) => exam.id !== MOCK_ASSESSMENT_ID)
        .map((type) => {
          return {
            label: type.name,
            value: type.id,
          };
        });

      setExamOptions(updatedTypes);
    }
  }, [props.inviteCode.iroExamTypes]);

  useEffect(() => {
    let schoolIro = props.inviteCode.schoolIro;

    if (schoolIro && schoolIro.result && props.inviteCode.schoolEditInfo) {
      setSchoolIroEnableData((prevData) => {
        // Assuming each item has a unique key
        const formatKey = (test, date) =>
          `${date}-${test}-${props.inviteCode.schoolEditInfo.id}`;

        const existingIds = new Set(
          prevData.examDatesTable.map((item) =>
            formatKey(item.test_type, item.exam_date)
          )
        );
        const newUniqueResults = schoolIro.result.filter(
          (item) => !existingIds.has(formatKey(item.test_type, item.exam_date))
        );

        return {
          ...prevData,
          isEnableSchoolIro: schoolIro.result.length > 0 ? true : false,
          examDatesTable:
            schoolIro.offset === 0
              ? schoolIro.result
              : [...prevData.examDatesTable, ...newUniqueResults],
        };
      });
    }

    if (schoolIro && schoolIro.has_next) {
      props.inviteCode.getSchoolIro(
        props.inviteCode.schoolEditInfo.id,
        schoolIro.next_page
      );
    }
  }, [props.inviteCode.schoolIro]);

  const handleCheckboxChange = (event) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      isEnableSchoolIro: event.target.checked,
    });

    props.schoolIroFormUpdated();
  };

  // const handleExamCompleteCheckboxChange = (event, exam) => {
  //   let examStatus = schoolIroEnableData.examStatus;

  //   if (examStatus) {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: {
  //         ...schoolIroEnableData.examStatus,
  //         [exam.value]: true,
  //       },
  //     });
  //   } else {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: { [exam.value]: true },
  //     });
  //   }

  //   props.inviteCode.setSchoolIroCompletionStatusFormData({
  //     ...schoolIroEnableData,
  //     examStatus: examStatus
  //       ? {
  //           ...schoolIroEnableData.examStatus,
  //           [exam.value]: true,
  //         }
  //       : { [exam.value]: true },
  //   });
  // };

  const handleGradeChange = (event) => {
    // console.log("value selected:",event.target.value);
    // add the grade to schoolIroEnableData.selectedGrades
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      selectedGrades: [...event],
    });

    // for every object in event get the id of the object and make a list

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      selectedGrades: event,
    });

    props.schoolIroFormUpdated();
  };

  const updateSchoolIroFormData = (data) => {
    props.inviteCode.setSchoolIroFormData(data);
  };

  // const handleEnableDateChange = (date) => {
  //   setSchoolIroEnableData({
  //     ...schoolIroEnableData,
  //     examDate: moment(date).format("YYYY-MM-DD"),
  //   });

  //   updateSchoolIroFormData({
  //     ...schoolIroEnableData,
  //     examDate: moment(date).format("YYYY-MM-DD"),
  //   });

  //   props.schoolIroFormUpdated();
  // };

  const handleExamStartDate = (date) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      start_date: moment(date).format("YYYY-MM-DD"),
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      start_date: moment(date).format("YYYY-MM-DD"),
    });

    props.schoolIroFormUpdated();
  };

  const handleExamEndDate = (date) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      end_date: moment(date).format("YYYY-MM-DD"),
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      end_date: moment(date).format("YYYY-MM-DD"),
    });

    props.schoolIroFormUpdated();
  };

  const onDatepickerRef = (el) => {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  };

  const handleExamTypeChange = (e) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      test_id: e.value,
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      test_id: e.value,
    });

    props.schoolIroFormUpdated();
  };

  const handleExamSectionSelection = (e) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      exam_section: e.value,
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      exam_section: e.value,
    });

    props.schoolIroFormUpdated();
  };

  const handleUserTypeChange = (e) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      user_type: e.value,
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      user_type: e.value,
    });

    props.schoolIroFormUpdated();
  };

  // useEffect(() => {
  //   if (props.inviteCode.examStatus) {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: props.inviteCode.examStatus,
  //     });
  //   }
  // }, [props.inviteCode.examStatus]);

  useEffect(() => {
    const fetchTreeData = async () => {
      let { school } = schoolIroEnableData;
      let nonEligibleGrades = ["Nursery", "Junior KG", "Senior KG"];

      if (!gradeOption.length > 0) return;

      const tree = [];

      for (let grade of gradeOption) {
        if (nonEligibleGrades.includes(grade.label)) {
          continue;
        }

        let data = {
          school: props.inviteCode.schoolEditInfo
            ? props.inviteCode.schoolEditInfo.id
            : school,
          grade: grade.value,
        };
        const res = await userApi.getSections(data);

        if (res && Object.keys(res).length > 0) {
          const gradeNode = {
            title: grade.label,
            key: `grade:${grade.value}`,
            // disabled: true,
            children: res
              ? Object.keys(res).map((section) => ({
                title: res[section],
                key: section,
                isLeaf: true,
              }))
              : [],
          };

          tree.push(gradeNode);
        }
      }

      setTreeData(tree);
      // setExpandedKeys(keysToExpand);
    };

    fetchTreeData();
  }, [gradeOption, schoolIroEnableData.school]);

  const handleGradeSectionSelection = (checkedKeysObj) => {
    const { checked } = checkedKeysObj;

    const selectedGrades = [];
    const selectedSections = [];

    checked.forEach((key) => {
      if (key.startsWith("grade")) {
        // Only add grade if none of its children are selected
        const gradeId = key.split(":")[1];
        const gradeNode = treeData.find((g) => g.key === key);
        const sectionKeys = gradeNode.children.map((c) => c.key) || [];

        const isAnyChildChecked = sectionKeys.some((sKey) =>
          checked.includes(sKey)
        );

        if (!isAnyChildChecked) {
          selectedGrades.push(gradeId);
        }
      } else {
        selectedSections.push(key);
      }
    });

    setCheckedKeys(checked); // if you are controlling the state
    setSchoolIroEnableData((prev) => ({
      ...prev,
      selectedGrades,
      selectedSections,
    }));

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      selectedGrades,
      selectedSections,
    });

    props.schoolIroFormUpdated();
  };

  const formatGrades = (record) => {
    const gradeMap = {};

    // Map school_class into grade -> section list
    if (record.school_class) {
      record.school_class.forEach(({ name, grade }) => {
        if (!gradeMap[grade]) gradeMap[grade] = new Set();
        gradeMap[grade].add(name);
      });
    }

    // Add grades without sections (from record.grade)
    if (record.grade) {
      record.grade.forEach((grade) => {
        if (!gradeMap[grade]) gradeMap[grade] = new Set();
      });
    }

    // Format into "Grade 1 - A, B", "Grade 3", etc.
    const parts = Object.entries(gradeMap).map(([grade, sections]) => {
      if (sections.size > 0) {
        return `${grade} - ${Array.from(sections).join(", ")}`;
      }
      return grade;
    });

    return parts.join("; ");
  };

  return (
    props.inviteCode.schoolEditInfo && (
      <div className="mt-4">
        <div>
          <label>
            <CheckBox
              checked={schoolIroEnableData.isEnableSchoolIro}
              onChange={handleCheckboxChange}
              disabled={
                props.inviteCode.schoolEdit
                  ? !props.inviteCode.schoolEdit
                  : true
              }
            />
            <span style={{ marginLeft: 8 }}>Enable IRO</span>
          </label>
        </div>

        {schoolIroEnableData.isEnableSchoolIro && (
          <Table>
            <thead>
              <Tr className="text-center">
                <Th>Exam Date Range</Th>
                <Th>Exam Name</Th>
                <Th>Grades</Th>
                <Th>User Type</Th>
              </Tr>
            </thead>
            <tbody>
              {schoolIroEnableData.examDatesTable &&
                schoolIroEnableData.examDatesTable.length > 0 &&
                schoolIroEnableData.examDatesTable.map((exam, index) => (
                  <Tr key={index}>
                    <Td
                      style={{ width: "30%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.start_date} to {exam.end_date}
                    </Td>
                    <Td
                      style={{ width: "20%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.test_name} <br/> {exam.exam_section}
                    </Td>
                    <Td
                      style={{ width: "35%", padding: "10px" }}
                      className="text-center"
                    >
                      {formatGrades(exam)}
                    </Td>
                    <Td
                      style={{ width: "15%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.user_type}
                    </Td>
                  </Tr>
                ))}
            </tbody>
          </Table>
        )}
        {schoolIroEnableData.isEnableSchoolIro && (
          <div>
            <DropDownContainer>
              <DropDownTitle>EXAM TYPE</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select exam type"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleExamTypeChange}
                options={examOptions.length > 0 && examOptions}
                isMulti={false}
              />
            </DropDownContainer>
            <DropDownContainer>
              <DropDownTitle>EXAM SECTION</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select exam type"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleExamSectionSelection}
                options={examSections.length > 0 && examSections}
                isMulti={false}
              />
            </DropDownContainer>
            <DropDownContainer>
              <DropDownTitle>USER TYPES</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select user type"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleUserTypeChange}
                options={userTypes}
                isMulti={false}
              />
            </DropDownContainer>
            <DropDownContainer>
              <DropDownTitle>SCHOOL GRADES</DropDownTitle>
              {/* <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select school grades"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleGradeChange}
                options={gradeOption}
                isMulti={true}
              /> */}
              <Tree
                checkable
                onCheck={(keys) => handleGradeSectionSelection(keys)}
                checkedKeys={checkedKeys}
                treeData={treeData}
                defaultExpandAll
                autoExpandParent={true}
                showIcon={false}
                checkStrictly={true}
                disabled={!props.inviteCode.schoolEdit}
              />
            </DropDownContainer>

            {/* <DatePickerContainer>
              <h6>Exam Date</h6>
              <DateSelector
                style={{ overflow: "hidden", border: "1px solid #a349c9" }}
              >
                <DateSelectorIcon className="fa fa-calendar" />
                <DatePicker
                  selected={schoolIroEnableData.examDate}
                  selectsStart
                  startDate={schoolIroEnableData.examDate}
                  onChange={handleEnableDateChange}
                  minDate={moment().toDate()}
                  placeholderText="Select Enable Date"
                  disabled={
                    props.inviteCode.schoolEdit
                      ? !props.inviteCode.schoolEdit
                      : true
                  }
                  ref={(el) => onDatepickerRef(el)}
                />
              </DateSelector>
            </DatePickerContainer> */}

            <div style={{ display: "flex", width: '100%' }}>
              <DatePickerContainer>
                <h6>Start Date</h6>
                <DateSelector
                  style={{ overflow: "hidden", border: "1px solid #a349c9" }}
                >
                  <DateSelectorIcon className="fa fa-calendar" />
                  <DatePicker
                    selected={schoolIroEnableData.start_date}
                    selectsStart
                    startDate={schoolIroEnableData.start_date}
                    onChange={handleExamStartDate}
                    minDate={moment().toDate()}
                    placeholderText="Select start date"
                    disabled={
                      props.inviteCode.schoolEdit
                        ? !props.inviteCode.schoolEdit
                        : true
                    }
                    ref={(el) => onDatepickerRef(el)}
                  />
                </DateSelector>
              </DatePickerContainer>
              &nbsp;
              <DatePickerContainer>
                <h6>End Date</h6>
                <DateSelector
                  style={{ overflow: "hidden", border: "1px solid #a349c9" }}
                >
                  <DateSelectorIcon className="fa fa-calendar" />
                  <DatePicker
                    selected={schoolIroEnableData.end_date}
                    selectsStart
                    startDate={schoolIroEnableData.end_date}
                    onChange={handleExamEndDate}
                    minDate={moment().toDate()}
                    placeholderText="Select end date"
                    disabled={
                      props.inviteCode.schoolEdit
                        ? !props.inviteCode.schoolEdit
                        : true
                    }
                    ref={(el) => onDatepickerRef(el)}
                  />
                </DateSelector>
              </DatePickerContainer>
            </div>

            {/* <div className="mt-4">
              <p>Iro Exam Completion Status</p>
              {examOptions.length > 0 &&
                examOptions.map((exam) => (
                  <div className="mt-4">
                    <label>
                      <CheckBox
                        checked={
                          // props.inviteCode.examStatus &&
                          // props.inviteCode.examStatus[exam.value]
                          //   ? props.inviteCode.examStatus[exam.value]
                          //   :
                          schoolIroEnableData.examStatus &&
                          schoolIroEnableData.examStatus[exam.value]
                            ? schoolIroEnableData.examStatus[exam.value]
                            : false
                        }
                        onChange={(e) =>
                          handleExamCompleteCheckboxChange(e, exam)
                        }
                        disabled={
                          props.inviteCode.schoolEdit
                            ? !props.inviteCode.schoolEdit
                            : true
                        }
                      />
                      <span style={{ marginLeft: 8 }}>{exam.label}</span>
                    </label>
                  </div>
                ))}
            </div> */}
          </div>
        )}
      </div>
    )
  );
}

export default withRouter(
  connectStore({
    inviteCode,
    onboard,
    product,
  })(SchoolIroEnable)
);

